import {inject, Injectable} from '@angular/core';
import {ApiService, Tables} from "../../../services/api.service";
import {Observable} from "rxjs";
import {EscalationAction, EscalationLog, EscalationStatus, LoggingEvent, LogObject} from "../escalation.model";

@Injectable({
  providedIn: 'root'
})
export class EscalationLoggingService {
  apiService = inject(ApiService)

  logEscalation(escalation: LogObject, event: LoggingEvent): Observable<EscalationLog> {
    console.log('escalation data', escalation)
    let logMessage;
    switch (event) {
      case "create":
        logMessage = `New Escalation created`;
        break;
      case "emailNotification":
        if (!escalation.assignedToUser) {
          logMessage = `No email notification sent`;
        } else {
          logMessage = `Email notification sent to user ${escalation.assignedToUser}`;
        }
        break;
      case "accept":
        logMessage = `Escalation accepted by ${escalation.assignedToUser}`
        break;
      case "process":
        logMessage = `Processing of escalation started by ${escalation.assignedToUser}`;
        break;
      case "complete":
        logMessage = `Escalation completed`
        break;
      case "error":
        logMessage = `An error occurred: ${escalation.errorMessage}`;
        break;
      case "takeover":
        logMessage = `Escalation taken over by ${escalation.assignedToUser}`;
        break;
    }
    return this.apiService.addAndReturnItem<EscalationLog>(Tables.EscalationLog, {
      escalation_id: escalation.id,
      report: escalation.reportId,
      log_message: logMessage
    })
  }

  getLoggingEvent(action: EscalationAction): LoggingEvent {
    switch (action) {
      case 'accept':
        return 'accept';
      case 'inProgress':
        return 'process';
      case 'takeover':
        return 'takeover';
      default:
        return 'error'; // Fallback, should not happen
    }
  }
}
